var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16652 1.33352H8.83318C7.84999 1.33097 6.8784 1.56109 5.99928 2.00514C3.85643 3.07609 2.50078 5.26821 2.49985 7.66661L2.50405 7.91218C2.53111 8.64785 2.68818 9.37309 2.96734 10.0539L3.04918 10.2429L1.8674 13.7894L1.8478 13.8602C1.7388 14.3542 2.21319 14.7985 2.71067 14.6327L6.25652 13.4502L6.44619 13.5327C7.20265 13.8429 8.01416 14.0023 8.83492 14.0002C11.2318 13.9993 13.424 12.6436 14.4962 10.4982C14.939 9.62165 15.1691 8.65006 15.1665 7.66515L15.1665 7.33354C14.9914 4.14056 12.514 1.60736 9.38126 1.34684L9.16652 1.33352ZM8.83199 2.668L9.13904 2.66736L9.13032 2.66699C11.6682 2.80702 13.6947 4.8335 13.8347 7.37142L13.8337 7.66802C13.8357 8.44467 13.6547 9.20911 13.3053 9.90079C12.4575 11.597 10.7269 12.6673 8.83345 12.668C8.05706 12.67 7.29263 12.489 6.60095 12.1396L6.51969 12.1051C6.38135 12.0569 6.23008 12.0554 6.08956 12.1022L3.55371 12.9474L4.3995 10.4122C4.45571 10.2435 4.44225 10.0594 4.36211 9.90079C4.01274 9.2091 3.83169 8.44467 3.83371 7.66976C3.83444 5.77481 4.90469 4.04419 6.59842 3.19769C7.29263 2.84705 8.05706 2.666 8.83199 2.668Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_icon.16cb12d3c13a0d7f91cdf8f518e2830a.svg";
export { ForwardRef as ReactComponent };